

import mixx from "../../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  name: "terminales",
  data() {
    return {
      loading: false,
   
      tbv: null,
    };
  },

  computed: {},
  mounted: function() {

    this.tbv = $("#venta2s").DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': false,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true
    });


    window.comp1 = this;
    $(".box").boxWidget();
    this.archivos();

  },

  methods: {
    archivos() {
      this.tbv.clear();
      this.loading = true;

      this.$http
        .post(
          "SERVER/scd/configs/",
          {
            a: "files"
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status == 1) {
            for (let i = 0; i < response.data.data.length; i++) {

              let est='En proceso';


              if ( response.data.data[i][2]==1) {
                est='<div style="font-size:14px" class="btn-block btn bg-green">Procesado</div>';

              }else if ( response.data.data[i][2]==2){

                est='<div style="font-size:14px" class="btn-block btn bg-blue">En proceso</div>';
              }else{

                est='<div style="font-size:14px" class="btn-block btn bg-yellow">En cola</div>';
              }

            
              let btn='<a download=""  href="" disabled class="btn btn-block btn-primary">Descargar</a>';


              if (response.data.data[i][2]==1) {
                btn= '<a   download="'+response.data.data[i][3]+'" href="SERVER/scd/download/?dsis='+window.sssdi+'&a=fileC&f='+response.data.data[i][4]+'" class="btn btn-block btn-primary">Descargar</a>';
               
              }

              this.tbv.row.add([
                response.data.data[i][0],
                response.data.data[i][1],
                est,
                btn,
               
              ]);
            }
          }

          this.tbv.draw();

          this.loading = false;
        });
    },

  }
};




// WEBPACK FOOTER //
// ./src/components/configs/archivos/main/index.js